import { useAuth0 } from '@auth0/auth0-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createUserAuth0 } from '../../../api/auth0Api';
import toast from 'react-hot-toast';

const useCreateUser = () => {
  const queryClient = useQueryClient();
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const { getAccessTokenSilently } = useAuth0();
  return useMutation({
    mutationFn: async (values) => {
      toast.loading('Creando usuario...', {
        id: 'create-user',
      });
      const token = await getAccessTokenSilently();
      return await createUserAuth0(token, values);
    },
    onSuccess: async () => {
      await sleep(1000);

      queryClient.invalidateQueries(['user']);
      queryClient.invalidateQueries(['all-users']);
      toast.success('Se ha creado el usuario con éxito.');
    },
    onError: (error) => {
      if (error?.response?.data?.message === 'The user already exists.') {
        return toast.error('Ya existe un usuario con ese email.');
      }
      toast.error('Se ha producido un error al crear el usuario.');

      console.log('error', error?.response?.data?.message);
    },
    onSettled: () => {
      toast.dismiss('create-user');
    },
  });
};

export default useCreateUser;
